// PC + リール型のループで複製スライドが増えるため、元コンテンツ数に正規化する
export const getSquareContentsCount = (campaign = window.storeeelItems) => {
  const groups = campaign?.contentGroups || [];
  return groups.reduce((sum, group) => sum + (group?.contents?.length || 0), 0);
};

export const normalizeSquareContentIndex = (index, campaign = window.storeeelItems) => {
  const count = getSquareContentsCount(campaign);
  const raw = Number(index);
  if (!Number.isFinite(raw) || count <= 0) return 0;
  const mod = raw % count;
  return mod < 0 ? mod + count : mod;
};
